import { Image, ImageFitType, ImageWrapper } from "@jmc/solid-design-system/src/components/organisms/Image/Image";
import { useJnjBranding } from "@jmc/utils/hooks/useJnjBranding";
import { CMSImageProps } from "@jwm/types/CMSImageProps";
import { GatsbyImage } from "gatsby-plugin-image";
import React from "react";
import { useTranslation } from "react-i18next";

interface Props {
    extension: string;
    image: CMSImageProps;
    loading?: "lazy" | "eager";
}

export const JWMNonLinkedImage = (props: Props): JSX.Element => {
    const { extension = "jpg", image, loading = "lazy" } = props;
    const { t } = useTranslation();
    const { jnjFullBranded } = useJnjBranding();

    const imageFit = image?.fit?.toLowerCase() as ImageFitType;
    const isFitNone = imageFit === "none";
    const originalImgHeight = image?.image?.dimension?.height;
    const objectFit = isFitNone ? "cover" : imageFit;
    const styles = isFitNone
        ? {
              height: `${originalImgHeight}px`,
          }
        : { maxWidth: "100%", maxHeight: "100%" };
    const scaleDownImageStyle =
        imageFit === "scale-down"
            ? {
                  width: "100%",
                  maxWidth: `${image?.image?.dimension?.width}px`,
                  maxHeight: `${image?.image?.dimension?.height}px`,
              }
            : undefined;
    return extension === "svg" || extension === "gif" ? (
        <Image
            url={image?.image?.url}
            enableLightBox={image?.enable_lightbox}
            disableIcon={image?.disable_lightbox_image_link_icon}
            alt={image?.alt_text || image?.image?.description || ""}
            caption={image?.caption}
            title={image?.title || image?.alt_text}
            fit={imageFit}
            sizing={scaleDownImageStyle}
            loading={loading}
            enlargeLabel={t("Enlarge image", { ns: "common" })}
            horizontalAlignment={jnjFullBranded ? "start" : "center"}
        />
    ) : (
        <ImageWrapper
            enableLightBox={image?.enable_lightbox}
            disableIcon={image?.disable_lightbox_image_link_icon}
            url={image?.image?.url}
            sizing={scaleDownImageStyle}
            enlargeLabel={t("Enlarge image", { ns: "common" })}
            caption={jnjFullBranded && image?.caption}
            horizontalAlignment={jnjFullBranded ? "start" : "center"}
        >
            <GatsbyImage
                image={image?.image?.gatsbyImageData}
                alt={image?.alt_text || image?.image?.description || ""}
                title={image?.title || image?.alt_text}
                caption={image?.caption}
                objectFit={objectFit}
                style={styles}
                loading={loading}
            />
        </ImageWrapper>
    );
};
export default JWMNonLinkedImage;
